import { differenceInMinutes } from "date-fns";
import {
  TIMELINE_BASE_DAY_WIDTH,
  TIMELINE_MINUTES_IN_DAY,
} from "./timelineConstants";

const TIMELINE_SCROLL_HORIZONTAL_PADDING_PX = 80;
const TIMELINE_SCROLL_VERTICAL_PADDING_PX = 24;

/**
 * Computes horizontal and vertical scroll offsets to bring an event into view.
 * @param {Object} args
 * @param {Date} args.eventStart
 * @param {Date} args.viewStartDate
 * @param {number} args.daysToShow
 * @param {number} args.zoom
 * @param {number} args.resourceRowTop
 * @param {number} args.resourceRowHeight
 * @param {number} args.viewportWidth
 * @param {number} args.viewportHeight
 * @param {number} args.totalContentHeight
 * @returns {{ horizontalScrollLeft: number, verticalScrollTop: number }}
 */
export const computeTimelineScrollMetrics = ({
  eventStart,
  viewStartDate,
  daysToShow,
  zoom,
  resourceRowTop,
  resourceRowHeight,
  viewportWidth,
  viewportHeight,
  totalContentHeight,
}) => {
  const minutesFromViewStart = differenceInMinutes(eventStart, viewStartDate);
  const dayWidth = TIMELINE_BASE_DAY_WIDTH * zoom;
  const eventLeft =
    (minutesFromViewStart / TIMELINE_MINUTES_IN_DAY) * dayWidth;

  const contentWidth = daysToShow * dayWidth;
  const maxHorizontalScroll = Math.max(0, contentWidth - viewportWidth);
  let horizontalScrollLeft =
    eventLeft - viewportWidth / 2 + TIMELINE_SCROLL_HORIZONTAL_PADDING_PX;
  horizontalScrollLeft = Math.min(
    Math.max(horizontalScrollLeft, 0),
    maxHorizontalScroll,
  );

  const resourceCenter = resourceRowTop + resourceRowHeight / 2;
  const maxVerticalScroll = Math.max(0, totalContentHeight - viewportHeight);
  let verticalScrollTop = resourceCenter - viewportHeight / 2;
  verticalScrollTop = Math.min(
    Math.max(verticalScrollTop, TIMELINE_SCROLL_VERTICAL_PADDING_PX),
    maxVerticalScroll,
  );

  return {
    horizontalScrollLeft,
    verticalScrollTop,
  };
};
